import api from "src/api/service";

export const logging = (type: string, data?: string) => {
  try {
    api.loggingAction(type, data);
  } catch (e) {
    console.warn("fail to send log", e);
  }
};
